import ApiService from "./api.service";

const ContactService = {
  async vehicleTyres() {
    try {
      return await ApiService.get("vehicleTyres");
    } catch (error) {
      return error.response;
    }
  },
  async contactServices() {
    try {
      return await ApiService.get("contact-service-info");
    } catch (error) {
      return error.response;
    }
  },
  async showDescription() {
    try {
      return await ApiService.get(`contact-service-description`);
    } catch (error) {
      return error.response;
    }
  },
};

export { ContactService };
